exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sp-footer-enter-active[data-v-c7b4af7a],\n.sp-footer-leave-active[data-v-c7b4af7a] {\n  transition: opacity 0.3s;\n}\n.sp-footer-enter-active .box[data-v-c7b4af7a],\n.sp-footer-leave-active .box[data-v-c7b4af7a] {\n  transition: all 0.3s;\n}\n.sp-footer-enter[data-v-c7b4af7a],\n.sp-footer-leave-to[data-v-c7b4af7a] {\n  opacity: 0;\n}\n.sp-footer-enter .box[data-v-c7b4af7a],\n.sp-footer-leave-to .box[data-v-c7b4af7a] {\n  transform: translateY(100%);\n}", ""]);

// exports
